export const closeOutIcon = (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line opacity="0.5" x1="1.03328" y1="17.1187" x2="17.8159" y2="0.336128" stroke="black" strokeWidth="0.791139" />
    <line opacity="0.5" x1="1.59319" y1="0.50447" x2="18.3758" y2="17.2871" stroke="black" strokeWidth="0.791139" />
  </svg>
);
